import { type LinkStyleColor } from '../../components/common-components/link/link.types';

const styles = {
	primary: 'underline underline-hover hover-theme-primary-dark',
	internal: 'underline underline-hover hover-theme-internal-dark',
	'grey-darker': 'no-underline underline-hover hover-theme-black',
	white: 'no-underline underline-hover',
	grey: 'no-underline underline-hover hover-theme-grey-dark',
	success: 'underline underline-hover'
};

export const getLinkStyles = (color: string) => {
	return styles[color] || 'no-underline no-underline-hover';
};

const textButtonStyles: Record<LinkStyleColor, string[]> = {
	primary: styles.primary.split(' '),
	internal: styles.internal.split(' '),
	'grey-darker': ['hover-theme-black'],
	white: ['hover-theme-white', 'underline-hover'],
	grey: ['hover-theme-grey-dark', 'underline-hover'],
	success: [],
	warning: []
};

export const getTextButtonStyles = (color: LinkStyleColor): string[] => {
	return textButtonStyles[color] || [];
};
